import React, { FC } from 'react'
import styles from 'styles/components/image.module.scss'

const SentMailIcon: FC = () => {
  return (
    <div className={styles.icon__mail}>
      <img src={'/icon/done/mail.svg'} alt={'パスワードリセットリンクを送信しました'} />
    </div>
  )
}

export default SentMailIcon
